const region = "us-east-1";
const origin = window.location.origin;

const staging = {
  appSettingsData: {
    // generate a file format limit of video file
    federatedEngageAIProvider: "wl-idp-stg-engage-gpt-ident-prov",
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: region,
      userPoolId: "us-east-1_SPxOQIqTg",
      userPoolWebClientId: "6td6pogau19otc3a8uhhnegoam",
    },
    oauth: {
      domain: "auth.stg.gpt.wl-engage.com",
      scope: [],
      redirectSignIn: `${origin}/chat`,
      redirectSignOut: `${origin}/chat`,
      responseType: "code",
      clientId: "6td6pogau19otc3a8uhhnegoam",
    },
    API: {
      endpoints: [
        {
          name: "engage-gpt",
          // endpoint: "https://api.dev.wl-dms.com",
          endpoint: "https://api.stg.gpt.wl-engage.com",
          region: region,
        },
      ],
    },
  },
};
// type demoType = typeof demo
// type StagingType = typeof staging

export type StagingType = typeof staging;
export default staging;
